import useCheckPrice from './hooks/useCheckPrice'
import useFetchedData from 'hooks/useFetchedData'
// import RequestManager from 'api/RequestManager'
import { useAuth } from 'contexts/AuthContext'
import { lastorderinfo } from 'api/urls'
import React/* , { useEffect } */ from 'react'
import Loader from 'components/Loader'
import OrderForm from './Form'
import './index.scss'

const Order: React.FC = () => {
  const { isLoading, checkPrice, reload } = useCheckPrice()
  const { isAuth } = useAuth()

  // useEffect(() => {
  //   if (window.location.search.includes('token')) {
  //     const query = new URLSearchParams(window.location.search)
  //     const token = query.get('token')
  //     if (token) {
  //       RequestManager.jwt.set(token)
  //     }
  //   }
  // }, [])

  if (isLoading) return <Loader type='full' />
  if (isAuth /* || window.location.search.includes('token') */) return (
    <OrderWithFilledData
      checkPrice={checkPrice}
      reloadProducts={reload}
    />
  )
  return (
    <OrderForm
      checkPrice={checkPrice}
      reloadProducts={reload}
    />
  )
}

const OrderWithFilledData: React.FC<{ checkPrice?: order.CheckPrice, reloadProducts: (_?: string) => void }> = ({ checkPrice, reloadProducts }) => {
  const { isLoading, data } = useFetchedData<order.Cart>(lastorderinfo, '', 'POST')
  if (isLoading) return <Loader type='full' />
  return (
    <OrderForm
      checkPrice={checkPrice}
      lastOrder={data || undefined}
      reloadProducts={reloadProducts}
    />
  )
}

export default Order